export const isLastEntryOfDay = (schedule, index) => schedule.length === index + 1
